"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listGroup = void 0;
var listGroup = {
  padding: {
    left: '0'
  },
  margin: {
    bottom: '0'
  },
  border: {
    aLiFlushRight: '0',
    aLiFlushLeft: '0',
    aLiFlushFirstChildTop: '0',
    aLiFlushLastChildBottom: '0'
  },
  borderRadius: function borderRadius(get) {
    return get('globals', 'borderRadius');
  }
};
exports.listGroup = listGroup;


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-config/lib/theme/listGroup.js
// module id = 1174
// module chunks = 0